export const SET_TIPPANI = 'SET_TIPPANI';
export const SET_SELECTED_TIPPANI = 'SET_SELECTED_TIPPANI';
export const SET_GENERATED_TIPPANI = 'SET_GENERATED_TIPPANI';

export const SET_TRANSFER_DATA = 'SET_TRANSFER_DATA';
export const SET_TRANSFER_TIPPANI_PRINT_CONTENT = 'SET_TRANSFER_TIPPANI_PRINT_CONTENT';
export const SET_TRANSFER_VOUCHER_NUMBER = 'SET_TRANSFER_VOUCHER_NUMBER';

export const SET_CERTIFICATION_TYPE = 'SET_CERTIFICATION_TYPE';
export const SET_CERTIFICATION_DATA = 'SET_CERTIFICATION_DATA';
export const SET_CERTIFICATION_PRINT_CONTENT = 'SET_CERTIFICATION_PRINT_CONTENT';
export const SET_VOUCHER_GENERATED = 'SET_VOUCHER_GENERATED';

export const SET_PRINT_CONTENT = 'SET_PRINT_CONTENT';
export const SET_PRINT_TYPE = 'SET_PRINT_TYPE';
export const SET_PRINT_CONTENT_ONLY = 'SET_PRINT_CONTENT_ONLY';
export const CLOSE_PRINT_CONTENT = 'CLOSE_PRINT_CONTENT';
export const SET_TIPPANI_VERIFICATION_MODAL = 'SET_TIPPANI_VERIFICATION_MODAL';
export const SET_FORWARD_PURPOSE = 'SET_FORWARD_PURPOSE';


